/*!
 * Copyright (c) Microsoft Corporation and contributors. All rights reserved.
 * Licensed under the MIT License.
 */
/**
 * Error types the Fluid Framework may report.
 * @legacy
 * @alpha
 */
export const FluidErrorTypes = {
    /**
     * Some error, most likely an exception caught by runtime and propagated to container as critical error
     */
    genericError: "genericError",
    /**
     * Throttling error from server. Server is busy and is asking not to reconnect for some time
     */
    throttlingError: "throttlingError",
    /**
     * Data loss error detected by Container / DeltaManager. Likely points to storage issue.
     */
    dataCorruptionError: "dataCorruptionError",
    /**
     * Error encountered when processing an operation. May correlate with data corruption.
     */
    dataProcessingError: "dataProcessingError",
    /**
     * Error indicating an API is being used improperly resulting in an invalid operation.
     */
    usageError: "usageError",
};
//# sourceMappingURL=error.js.map